/**
 * isVideoUrl — true when a stored media URL points at a video file.
 *
 * The CMS image fields (024-cms Phase U) are image-only uploads; video upload is
 * dual-mode ONLY on the lakiruutu `videoUrl` field. The stored value is a plain
 * `/media/...` (or absolute) URL with no MIME metadata, and that value can still
 * be a video (a legacy/stored `/media/*.mp4`, or a `videoUrl` upload). This
 * helper classifies that URL by its file extension so both the admin authoring
 * preview and the member-facing render can choose `<video>` vs `<img>` from the
 * same rule. Shared (not inlined) precisely so the two surfaces cannot drift.
 *
 * This RENDER classification is intentionally WIDER than the upload allowlist
 * (which admits only `mp4`/`webm`): it also classifies legacy and
 * externally-referenced video URLs that pre-date the allowlist, so they render
 * as `<video>` rather than a broken `<img>` — without weakening the upload gate
 * (the upload pre-check in `ImageUploadField` keeps its narrow mp4/webm set).
 *
 * Pure, no dependencies. The extension may be followed by a query string or
 * fragment (`?v=2`, `#t=10`) or sit at the very end of the URL. The stored value
 * is trimmed before classifying, so incidental surrounding whitespace does not
 * misroute a video URL to the `<img>` branch.
 */

const VIDEO_EXTENSION_PATTERN = /\.(mp4|webm|ogg|ogv|mov|qt|m4v|mkv|avi|flv|wmv|3gp|3g2)(\?|#|$)/i;

export function isVideoUrl(url: string): boolean {
  return VIDEO_EXTENSION_PATTERN.test(url.trim());
}
